<template>
  <div class="conversa-history">
    <iframe
      :src="conversaUrl"
      width="100%"
      height="600"
      frameborder="0"
      allowfullscreen
    >
    </iframe>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ConversaHistory',
  props: {
    protocolo: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('Login', ['token']),
    ...mapGetters('SetupApp', ['instanciaAplicacao', 'bundle']),
    conversaUrl () {
      const baseUrl = process.env.VUE_APP_CHAT_FRONT
      const token = this.token
      const bundle = this.bundle
      const instanciaAplicacao = this.instanciaAplicacao

      return `${baseUrl}/#/history?token=${token}&bundle=${bundle}&instanciaAplicacao=${instanciaAplicacao}&protocolo=${this.protocolo}`
    }
  }
}
</script>

<style scoped>
.conversa-history {
  padding: 15px;
}

iframe {
  border: 1px solid #ddd;
  border-radius: 4px;
}
</style>
